import { yes } from '@silverhand/essentials';

export const isDevFeaturesEnabled =
  process.env.NODE_ENV !== 'production' || yes(process.env.DEV_FEATURES_ENABLED);

/** Read deployment configuration from the HTML generated by the running server. */
export const getRelaxiApiEndpoint = (): string => {
  const runtimeEndpoint = typeof logtoSsr === 'object' ? logtoSsr.relaxiApiEndpoint : undefined;
  // Vite's standalone development server has no Logto SSR middleware.
  const endpoint =
    runtimeEndpoint ??
    (process.env.NODE_ENV === 'development'
      ? (process.env.RELAXI_API_ENDPOINT ?? 'https://localhost:8080')
      : undefined);

  if (!endpoint?.trim()) {
    throw new Error('RELAXI_API_ENDPOINT must be configured on the Logto server');
  }

  const url = new URL(endpoint);
  if (
    !['https:', 'http:'].includes(url.protocol) ||
    url.username ||
    url.password ||
    url.search ||
    url.hash
  ) {
    throw new Error(
      'RELAXI_API_ENDPOINT must be an HTTP(S) URL without credentials, query or fragment'
    );
  }
  return url.href.replace(/\/+$/, '');
};
